var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/16px/Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6928913,14 L1.30789126,14 C0.831391261,14 0.406891261,13.755 0.171891261,13.3445 C-0.0596087394,12.94 -0.0571087394,12.459 0.178391261,12.0575 L6.87039126,0.644 C7.10689126,0.241 7.52939126,0 8.00039126,0 C8.47139126,0 8.89389126,0.241 9.12989126,0.6445 L15.8223913,12.058 C16.0583913,12.46 16.0608913,12.941 15.8293913,13.345 C15.5943913,13.755 15.1693913,14 14.6928913,14 Z M1.04089126,12.5635 C0.968391261,12.687 1.00889126,12.7945 1.03939126,12.8475 C1.06589126,12.8935 1.14439126,13 1.30789126,13 L14.6928913,13 C14.8568913,13 14.9353913,12.893 14.9618913,12.847 C14.9923913,12.7945 15.0328913,12.6865 14.9603913,12.5635 L8.26739126,1.15 C8.18789126,1.015 8.05439126,1 8.00039126,1 C7.94639126,1 7.81289126,1.0145 7.73339126,1.15 L1.04089126,12.5635 Z M8.00039126,9.505 C7.72439126,9.505 7.50039126,9.2815 7.50039126,9.005 L7.50039126,5.005 C7.50039126,4.729 7.72439126,4.505 8.00039126,4.505 C8.27639126,4.505 8.50039126,4.729 8.50039126,5.005 L8.50039126,9.005 C8.50039126,9.2815 8.27639126,9.505 8.00039126,9.505 Z M8.00039126,11.505 C7.87039126,11.505 7.74039126,11.45 7.64539126,11.36 C7.55539126,11.265 7.50039126,11.135 7.50039126,11.005 C7.50039126,10.875 7.55539126,10.7445 7.64539126,10.65 C7.83039126,10.465 8.17039126,10.465 8.35539126,10.65 C8.44539126,10.7445 8.50039126,10.875 8.50039126,11.005 C8.50039126,11.135 8.44539126,11.265 8.35539126,11.36 C8.26039126,11.45 8.13539126,11.505 8.00039126,11.505 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/White",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/Grey-Darker/1---100%",
    mask: "url(#mask-2)",
    fill: "#9EA0A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.000000)",
    id: "Colour"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.603b4cbde705e60625056cd825d06e60.svg";
export { ForwardRef as ReactComponent };